let _ = require('lodash');
let css = require('./document.css');
let Head = require('../head');
let Devtools = require('../../devtools');
let Layout = require('../layout');
let singals = require('../../../signals/layout');

class Document {
    constructor (locator) {
        this.config = locator.resolve('config');
        this.template = require('./template.hbs');
    }

    bind () {
        document.body.addEventListener('click', () => {
            this.$context.signal(singals.closePopups);
        }, false);
    }

    render () {
        let envVars = this.config;

        let data = {
            isRelease: envVars.isRelease,
            css
        };

        if (this.$context.isBrowser) {
            return data;
        }

        let deniedEnvVars = require('../../../config/env.browser').denied;
        let vars = _.omit(envVars, deniedEnvVars);

        data.ENV = JSON.stringify(vars);

        return data;
    }
}

module.exports = {
    constructor: Document,
    children: [
        {
            name: 'head',
            component: Head,
            watcher: {
                title: ['title'],
                description: ['description']
            }
        },
        {
            name: 'devtools',
            component: Devtools
        },
        {
            name: 'layout',
            component: Layout,
            watcher: {
                layout: ['layout'],
                atCenter: ['page', 'ui', 'atCenter']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/layout/document/index.js